import React from "react";
import Header from "../../components/home/header/Header";
import Banner from "../../components/home/banner/Banner";

const Home = () => {
  return (
    <>
      <div>
        <Header />
        <Banner />
      </div>
    </>
  );
};

export default Home;
